export default __webpack_public_path__ + "static/media/luke.19febcd8.mp3";